import React from 'react';
import { useSelector } from 'react-redux';
import './SeeAllOptions.css';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';
import { PopupTitle, PopupContent, PopupFooter } from 'new-ui/Components/Popup';
import { useTranslation } from 'utils/modifiedTranslation';
import { OpenInNewTab } from 'new-ui/Components/OpenInNewTab';
import { DETACH_URL_SEARCH_PARAM, REMATCH_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';

const SeeAllOptions = () => {
  const { appConfiguration, profile: { data: user } } = useSelector((state) => ({
    appConfiguration: state.appConfiguration,
    profile: state.profile,
  }));
  const { t } = useTranslation();
  return (
    <div className="see-all-options">
      <PopupTitle title="Your results" />
      <PopupContent>
        <div>{t('popup.see_all_options.content_first')}</div>
        <div>
          {t('popup.see_all_options.content_third', {
            PARTNER_NAME: appConfiguration?.providerSpecific?.name,
            INDICATION_NAME: user.personal.condition_name,
          })}
        </div>
        <div className="info">{t('popup.see_all_options.content_second')}</div>
      </PopupContent>
      <PopupFooter>
        <a
          className="button see-all-options-button"
          href={`${ROUTE_PATH[ROUTE_NAME.RESULTS]}?${DETACH_URL_SEARCH_PARAM}=1&${REMATCH_URL_SEARCH_PARAM}=1`}
          target="_blank"
          onClick={() => {
            OpenInNewTab();
          }}
        >
          {t('popup.see_all_options_yes_button')}
        </a>
      </PopupFooter>
    </div>
  );
};

export default SeeAllOptions;
